import { useState } from 'react';
import { useSiteOverview } from '../SiteOverviewContext';
import ProductionAreas from './ProductionAreas';
import Regions from './Regions';
import SiteUnitProperties from './SiteUnitProperties';
import styles from './style.module.scss';

export enum FILTER_ID {
    SITE_NAME = 'siteName',
    AVG_WEIGHT = 'avgWeight',
    REGIONS = 'regions',
    PROD_AREAS = 'prodAreas',
    SITE_UNIT_PROPERTIES = 'siteUnitProperties',
    FISH_HEALTH = 'fishHealth',
    DISEASE = 'disease',
    LICE = 'lice',
    MORTALITY = 'mortality',
    HARVEST_SIZE = 'harvest-size',
    OVERLOAD_SITE = 'overload-site',
    OVERLOAD_UNIT = 'overload-unit',
}

const Filter: React.FC = () => {
    const [open, setOpen] = useState(false);
    const [isClosed] = useSiteOverview(state => state.isClosed);
    if (isClosed)
        return null;

    return <>
        <div className={styles.btFilter} onClick={() => setOpen(true)}>
            Filter
        </div>
        <div className={styles.filter} data-open={open}>
            <div className='sticky top-0 bg-[var(--bgHeader)] z-10 pt-[16px] flex justify-between items-center pb-2'>
                <div className='text-[20px]'>
                    Filter site, unit by:
                </div>
                <div className='bt-close' onClick={() => setOpen(false)} />
            </div>
            <div className='py-3 flex flex-col gap-2'>
                <Regions />
                <div className={styles.section}>
                    <ProductionAreas />
                </div>
                <div className={styles.section}>
                    <SiteUnitProperties />
                </div>
            </div>
        </div>
    </>
}

export default Filter;